export default __webpack_public_path__ + "static/europeHeader-0be42de50c308bd09867247c64692255.jpg";